import styled from 'styled-components';

const WrapperStyled = styled.div`
  z-index: 1;
  position: absolute;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContainerStyled = styled.div`
  background: #fff;
  padding: 40px 50px;
  mix-blend-mode: normal;
  opacity: 0.95;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;

  h1 {
    margin: 16px 0;
    font-size: 20px;
    color: #0e141d;
  }

  p {
    font-size: 16px;
    color: #494c66;
  }
`;

const ButtonVerify = styled.button`
  width: 296px;
  height: 44px;
  background: #e92070;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-top: 34px;

  &:hover {
    background: #fff;
    color: #e92070;
    border: 1px solid #e92070;
    cursor: pointer;
  }

  &:disabled {
    background: #c9cfd7;
    color: #fff;
    border: none;
    cursor: not-allowed;
  }
`;

const CancelAnchor = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #e92070 !important;
  margin-top: 20px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #494c66 !important;
  }
`;

const LoadingButton = styled(ButtonVerify)`
  background: #c9cfd7;
  color: #fff;
  width: 100%;

  &:hover {
    background: #c9cfd7;
    color: #fff;
    cursor: not-allowed;
    border: none;
  }
`;

export {
  WrapperStyled,
  ContainerStyled,
  ButtonVerify,
  CancelAnchor,
  LoadingButton,
};
